import { useUserContextSelector } from '@/redux';

export function useGetReportTemplateOwnerId(): string {
  const [isAdmin, id, adminOrganizationId] = useUserContextSelector((x) => [
    x.isAdmin,
    x.id,
    x.organizationId,
  ]);

  return isAdmin ? adminOrganizationId[0] : id;
}
